
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explorer",
      function () {
        return require("private-next-pages/explorer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explorer"])
      });
    }
  